<script>
import Nav from "@/components/Nav/index.vue";
import JsBarcode from "jsbarcode";
import axios from "axios";
import liff from "@line/liff";
import { nextTick } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import { Pagination } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
export default {
    name: "CouponDetail",
    data() {
        return {
            storeNo: '',
            txnNo: '',
            popup: '',
            swiperInstance: null,
            swiperIndex: 0,
            barcodes: [],
        };
    },
    components: {
        Nav,
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Pagination]
        }
    },
    computed: {
        hostUrl() {
            return this.$store.state.hostUrl;
        },
        selectedCouponItem() {
            return this.$store.state.selectedCouponItem;
        },
        showOnlineBox() {
            return this.selectedCouponItem?.usage === '線上領取';
        },
        showRedeemBox() {
            const item = this.selectedCouponItem;
            if (!item) return false;
            return item.usage !== '線上領取'
                && item.coupon_type === 'product_free_of_charge'
                && item.min_consumption_threshold === 0;
        },
        showCodeBox() {
            const item = this.selectedCouponItem;
            if (!item) return false;
            if (item.usage === '線上領取') return false;
            if (!item.coupon_no_list) return false
            if (item.coupon_type === 'product_free_of_charge' && item.min_consumption_threshold === 0) return false;
            return item.coupon_no_list?.length === 1;
        },
        showCodeBoxMulti() {
            const item = this.selectedCouponItem;
            if (!item) return false;
            if (item.usage === '線上領取') return false;
            if (!item.coupon_no_list) return false
            if (item.coupon_type === 'product_free_of_charge' && item.min_consumption_threshold === 0) return false;
            return item.coupon_no_list?.length > 1;
        },
        isBeforeStartDate() {
            const item = this.selectedCouponItem;
            if (!item || !item.use_start_at) return false;
            return new Date() < new Date(item.use_start_at);
        },
    },
    created() {
        if (this.showCodeBoxMulti) {
            this.barcodes = [...(this.selectedCouponItem.coupon_no_list)];
        }
    },
    mounted() {
        console.log('coupon_no:', this.$route.params.id);
        console.log('selectedCouponItem:', this.selectedCouponItem);
        if (this.showCodeBox) {
            nextTick(() => {
                this.initJsBarcode(this.selectedCouponItem.coupon_no_list[0]);
            });
        }
    },
    methods: {
        openUsageWebsite() {
            liff.openWindow({
                url: this.selectedCouponItem.usage_website,
                external: true,
            });
        },
        formatDate(str) {
            return str ? str.split(' ')[0].replace(/-/g, '/') : '';
        },
        copy(code) {
            navigator.clipboard.writeText(code).then(() => {
                alert('複製成功');
            }).catch(err => {
                console.error("複製錯誤：", err);
            });
        },
        onSwiper(swiper) {
            this.swiperInstance = swiper;
            nextTick(() => {
                this.initAllBarcodes();
            });
        },
        onSlideChange() {
            this.swiperIndex = this.swiperInstance.realIndex;
        },
        prevSlide() {
            this.swiperInstance && this.swiperInstance.slidePrev();
        },
        nextSlide() {
            this.swiperInstance && this.swiperInstance.slideNext();
        },
        initAllBarcodes() {
            this.barcodes.forEach((code, idx) => {
                JsBarcode(`#barcode-${idx}`, code, {
                    format: "CODE128",
                    lineColor: "#151415",
                    height: 60,
                    displayValue: false,
                    background: "transparent",
                });
            });
        },
        initJsBarcode(code) {
            JsBarcode("#barcode", code, {
                format: "CODE128",
                lineColor: "#151415",
                height: 60,
                displayValue: false,
                background: "transparent",
            });
        },
        closeAndBack() {
            this.popup = '';
            this.$router.push('/coupon');
        },
        submitRedeem() {
            const _this = this;
            const isVoucher = _this.showCodeBoxMulti || _this.showCodeBox;
            if (!_this.storeNo) {
                alert('請輸入店碼');
                return;
            }
            if (isVoucher && !_this.txnNo) {
                alert('請輸入交易序號末4碼');
                return;
            }
            if (isVoucher && !/^\d+$/.test(_this.txnNo)) {
                alert('交易序號只能輸入數字');
                return;
            }
            if (isVoucher && _this.txnNo.length < 4) {
                alert('交易序號不足4碼');
                return;
            }
            const data = {
                store_no: _this.storeNo,
                ...(isVoucher && { txn_no: _this.txnNo }),
                param: {
                    match_type: 'coupon_no',
                    value: _this.showCodeBoxMulti
                        ? _this.barcodes[_this.swiperIndex]
                        : _this.selectedCouponItem.coupon_no,
                },
            };
            _this.$store.commit('loadingToggle', true);
            axios.post(`${_this.hostUrl}member/coupon/gift_redeem`, data, {
                headers: {
                    Authorization: `Bearer ${_this.$store.state.userNbInfo.access_token}`,
                    'Content-Type': 'application/json',
                },
            }).then(r => {
                console.log(r)
                _this.$store.commit('loadingToggle', false);
                _this.popup = 'success';
            }).catch(error => {
                _this.$store.commit('loadingToggle', false);
                console.error(error);
                alert('兌換失敗\n'+error.response.data.error);
            });
        },
    }
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
